import { render, staticRenderFns } from "./NotificacoesWebhookPendentesTabela.vue?vue&type=template&id=ab8a66c6"
import script from "./NotificacoesWebhookPendentesTabela.vue?vue&type=script&lang=js"
export * from "./NotificacoesWebhookPendentesTabela.vue?vue&type=script&lang=js"
import style0 from "./NotificacoesWebhookPendentesTabela.vue?vue&type=style&index=0&id=ab8a66c6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports